$(function() {
    $('.js-form-reset-password').validate({
        rules: {
            password_confirm: {
                minlength: 8
            },
            password: {
                minlength: 8
            },
            password_repeat: {
                equalTo: '#password'
            }
        },
        submitHandler: function(form) {
            form.submit();
        }
    });
});